<!--new components-->
<mat-card
    [ngClass]="(deviceLg == true || deviceXl == true) ? 'm-10 m-xl-2 brder-class pd-t-3' : 'mat-card-center brder-class pd-t-3 m-10 m-xl-2'"
    class="document-card-container">
    <div
        class="cardHeader text-center d-flex flex-row align-items-center justify-content-center d-sm-flex flex-sm-row align-items-xl-center justify-content-sm-between d-md-flex flex-md-row align-items-md-center justify-content-md-between d-lg-flex align-items-lg-center flex-lg-row justify-content-lg-between d-xl-flex align-items-xl-center flex-xl-row justify-content-xl-between">
        <div
            class="col-4 d-flex justify-content-start align-items-center col-sm-4 d-sm-flex justify-content-sm-start align-items-sm-center col-md-4 d-md-flex justify-content-md-start align-items-md-center col-lg-4 d-lg-flex justify-content-lg-start align-items-lg-center col-xl-4 d-xl-flex justify-content-xl-start align-items-xl-center">
            <mat-icon class="cardheadIcon dboard-hdr-icon-color ">calendar_today</mat-icon>
            <h2 class="margin-0 dboard-hdr f-weight">My Documents</h2>
        </div>
        <div
            class="col-8 d-flex justify-content-end align-items-center col-sm-8 d-sm-flex justify-content-sm-end align-items-sm-center col-md-8 d-md-flex justify-content-md-end align-items-md-center col-lg-8 d-lg-flex justify-content-lg-end align-items-lg-center col-xl-8 d-xl-flex justify-content-xl-end align-items-xl-center">
            <table class="removeBorder">
                <tr>
                    <td class="brdr-left-solid removeBorder">
                        <div class="" id="date-range-filter-doc" hidden="true">

                            <mat-form-field class="date-range" [ngStyle]="deviceLg == true || deviceXl == true ? {} : {'width' : '85px'}"
                                floatLabel="auto">
                                <mat-label>Date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input readonly (focus)="picker.open()" matInput id="start-date" #start matStartDate
                                        placeholder="Start date" [(ngModel)]="startFilterDate">
                                    <input readonly (focus)="picker.open()" matInput id="end-date" #end matEndDate
                                        placeholder="End date" [(ngModel)]="endFilterDate">
                                </mat-date-range-input>
                                <mat-datepicker-toggle class="date-toggle-icon-alignment" id="calendar-click-icon-doc"
                                    matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker [formControl]="calendar">
                                    <mat-date-range-picker-actions>
                                        <button mat-button matDateRangePickerCancel>Cancel</button>
                                        <button mat-raised-button color="primary" matDateRangePickerApply
                                            (click)="triggerAlert()">Apply</button>
                                    </mat-date-range-picker-actions>
                                </mat-date-range-picker>
                                <mat-icon *ngIf="isShown" class="search-icon" (click)="triggerRefresh(0)"
                                    matSuffix>close</mat-icon>
                            </mat-form-field>
                        </div>
                    </td>
                    <td class="removeBorder">
                        <div class="pd-l-5" id="search-filter-doc">
                            <mat-form-field floatLabel="auto"
                                [ngStyle]="deviceLg == true || deviceXl == true ? {} : {'width' : '85px'}">
                                <input id="upc-search-field" matInput placeholder="Search" #input>
                                <mat-icon class="search-icon-alignment" matSuffix>search</mat-icon>
                                <mat-icon *ngIf="isShown || input.value" class="search-icon" (click)="triggerRefresh(0)"
                                    matSuffix>close</mat-icon>
                            </mat-form-field>
                        </div>
                    </td>
                    <td class="removeBorder">
                        <mat-icon *ngIf="!completed" class="filter-dropdown-icon-alignment pointer"
                            [matMenuTriggerFor]="menu">expand_more</mat-icon>
                        <mat-icon *ngIf="completed" class="filter-dropdown-icon-alignment pointer"
                            [matMenuTriggerFor]="comMenu">expand_more</mat-icon>
                    </td>
                    <td class="brdr-left-solid removeBorder">
                        <div class="d-flex align-items-center panel-icon-section">
                            <span>
                                <mat-icon tooltip="Enter Full Screen" triggers="hover" container="body"
                                    *ngIf="!sideNavService.returnExpandFullScreeBooleanSetter()"
                                    (click)="(deviceLg || deviceXl || deviceMd) ? sideNavService.expandFullScreenBooleanSetter(true,'document-card-container','panel-fullscreen') : sideNavService.expandFullScreenBooleanSetter(true,'document','panel-fullscreen-mb-view')"
                                    (click)="triggerRefresh(1)"
                                    class="pointer panel-icn-fold-unfold">fullscreen</mat-icon>
                                <mat-icon tooltip="Exit Full Screen" triggers="hover" container="body"
                                    *ngIf="sideNavService.returnExpandFullScreeBooleanSetter()"
                                    (click)="(deviceLg || deviceXl || deviceMd) ? sideNavService.expandFullScreenBooleanSetter(false,'document-card-container','panel-fullscreen') : sideNavService.expandFullScreenBooleanSetter(false,'document','panel-fullscreen-mb-view')"
                                    (click)="triggerRefresh(1)"
                                    class="pointer panel-icn-fold-unfold">fullscreen_exit</mat-icon>
                            </span>
                        </div>
                    </td>
                </tr>
            </table>

            <!--For completed document meeting-->

            <mat-menu #comMenu="matMenu" class="filter-drop-down">
                <button class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize"
                    mat-menu-item (click)="toggleFilter('oneWeek')">
                    <mat-icon class="mat-icon-menu">date_range</mat-icon>
                    <h3 class="mat-menu-content-alignment text-capitalize margin-0">previous week</h3>
                </button>
                <button class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize"
                    mat-menu-item (click)="toggleFilter('dateRange')">
                    <mat-icon class="mat-icon-menu">date_range</mat-icon>
                    <h3 class="mat-menu-content-alignment text-capitalize margin-0">date range</h3>
                </button>
            </mat-menu>



            <!--For Yet To completed document meeting-->


            <mat-menu #menu="matMenu" class="filter-drop-down">
                <button class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize"
                    mat-menu-item (click)="toggleFilter('twoWeek')">
                    <mat-icon class="mat-icon-menu">date_range</mat-icon>
                    <h3 class="mat-menu-content-alignment text-capitalize margin-0">next week</h3>
                </button>
                <button class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize"
                    mat-menu-item (click)="toggleFilter('nxtTwoWeek')">
                    <mat-icon class="mat-icon-menu">date_range</mat-icon>
                    <h3 class="mat-menu-content-alignment text-capitalize margin-0">next two weeks</h3>
                </button>
                <button class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize"
                    mat-menu-item (click)="toggleFilter('dateRange')">
                    <mat-icon class="mat-icon-menu">date_range</mat-icon>
                    <h3 class="mat-menu-content-alignment text-capitalize margin-0">date range</h3>
                </button>
            </mat-menu>
            <!-- </div> -->
        </div>
    </div>
    <mat-divider></mat-divider>
    <div>
        <div *ngIf="meetingDatasource.loading$ | async">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>

        <mat-tab-group mat-align-tabs="start" #tabGroup (selectedTabChange)="tabChanged($event)">
            <mat-tab class="body-font-size" label="Yet To Complete">
                <div class="meeting-indicator">
                    <mat-progress-spinner mode="indeterminate" [diameter]="20"
                        *ngIf="meetingDatasource.loading$ | async" bdColor="rgba(51,51,51,0.8)"></mat-progress-spinner>
                </div>
                <ng-scrollbar
                    [ngClass]="sideNavService.returnExpandFullScreeBooleanSetter() ? 'panel-fullscreen-card-inner-past-upcoming' : 'global-containers'"
                    #scrollable pointerEventsMethod="scrollbar" [disabled]="disabled">
                    <mat-table class="table-mat upcomming-mat-row" [dataSource]="meetingDatasource">

                        <ng-container matColumnDef="meetingDate" class="">
                            <mat-header-cell class="body-font-size upcomming-met-header" *matHeaderCellDef>Meeting
                                Date</mat-header-cell>
                            <mat-cell style="flex: none;" id="date-container"
                                [ngStyle]="sideNavService.returnExpandFullScreeBooleanSetter() && (deviceXl || deviceLg) ? {'width' : '185px'} : {}"
                                [ngClass]="!sideNavService.returnExpandFullScreeBooleanSetter() ? 'body-font-size upcomming-met-cell col-4 col-sm-2 col-md-2 col-lg-2 col-xl-2 pd-r-10px' : 'body-font-size upcomming-met-cell col pd-r-10px'"
                                *matCellDef="let meeting">
                                <div
                                    [ngStyle]="sideNavService.returnExpandFullScreeBooleanSetter() && (deviceLg || deviceXl) ? {'display' : 'contents'} : {}">
                                    <h4 style="margin: 0px;" class="f-weight line-height-1 no-wrap">
                                        {{meeting.meetingDateStr | date:'mediumDate'}}</h4>
                                    <h4 style="margin: 0px;"
                                        [ngClass]="sideNavService.returnExpandFullScreeBooleanSetter() && (deviceLg || deviceXl) ? 'pd-l-5' : ''">
                                        &#64; {{meeting.meetingStartTime}} {{meeting.meetingTimeZone}}</h4>
                                </div>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="meetingTitle">
                            <mat-header-cell class="body-font-size" *matHeaderCellDef>Meeting Title</mat-header-cell>
                            <mat-cell style="flex: none;"
                                [ngClass]="!sideNavService.returnExpandFullScreeBooleanSetter() ? 'col-xl-5 col-lg-8 col-md-6 body-font-size' : 'col-8 body-font-size'"
                                *matCellDef="let meeting; let index = index">
                                <h4 class="margin-0 a-link pointer f-weight" id="UPCOMING" [routerLink]=""
                                    (click)="viewMeeting(meeting)" tooltip="Go To Meeting Page" triggers="hover"
                                    placement="bottom" style="line-height: 1rem;">
                                    {{meeting.meetingTitle}}
                                    <br />
                                    <!-- <span style="font-size: 12px;
                                position: relative;
                                top: 0px;"> <span><a *ngIf = "index == 0" style="color: #589bfd;
                                    text-decoration: underline;cursor: pointer;" (click)="openAttachmentNotesDialog(meeting.meetingId)">To be Review</a></span></span>    -->
                                </h4>

                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="responsiveMeetingTitle">
                            <mat-header-cell class="body-font-size" style="line-height: 1rem;" *matHeaderCellDef>Meeting
                                Title</mat-header-cell>
                            <mat-cell style="flex: none;" class="col-sm-8 col-5 body-font-size"
                                *matCellDef="let meeting">
                                <h4 class="margin-0 a-link f-weight" id="UPCOMING" [routerLink]=""
                                    (click)="viewMeeting(meeting)" tooltip="Go To Meeting Page" triggers="hover"
                                    placement="bottom">{{meeting.meetingTitle}}</h4>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="meetingId">
                            <mat-header-cell class="body-font-size" *matHeaderCellDef>#</mat-header-cell>
                            <mat-cell style="flex: none;" *matCellDef="let meeting">{{meeting.meetingId}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="action">
                            <mat-header-cell class="body-font-size" *matHeaderCellDef>Meeting Action</mat-header-cell>
                            <mat-cell style="flex: none;"
                                [ngClass]="!sideNavService.returnExpandFullScreeBooleanSetter() ? 'body-font-size col-xl-2 col-lg-2 col-md-2 justify-content-end' : 'body-font-size col justify-content-end'"
                                *matCellDef="let meeting">
                                <button style="background-color: var(--strt-bttn-bg);color: var(--bttn-light);"
                                    *ngIf="meeting.meetingStartEnable == 'Y' && meeting.meetingStartFlag != 'Y'  && meeting.rescheduleFlag =='Y' && meeting.enableStartButton == 'Start'  && meeting.attendeeLoginFlag != 'Y'"
                                    mat-raised-button (click)="startMeeting(meeting)">
                                    START
                                </button>
                                <button
                                    *ngIf="(meeting.meetingStartEnable == 'N' || meeting.meetingStartFlag == 'Y' && meeting.meetingStartEnable == 'Y')  && meeting.rescheduleFlag =='Y' && meeting.enableStartButton == 'Start'  && meeting.attendeeLoginFlag != 'Y'"
                                    style="color: var(--bttn-light); background-color: #c4eb00;" mat-raised-button
                                    (click)="startMeeting(meeting)">
                                    JOIN
                                </button>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="getdetails">
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell style="flex: auto;" *matCellDef="let meeting"
                                [ngClass]="!sideNavService.returnExpandFullScreeBooleanSetter() ? 'col-lg-2 col-xl-4 justify-content-end upcomming_Info' : 'col-2 justify-content-end upcomming_Info'">
                                <!-- <mat-icon tooltip="Zoom meeting" placement="bottom" triggers="hover"
                            *ngIf="meeting.zoomMeetingId!=null"
                            (click)="startMeeting(meeting)" class="d-flex"> <img src="{{imageZoomSrc}}"></mat-icon> -->
                                <mat-icon style="cursor: pointer;"
                                    *ngIf="meeting.linkedMeetingInfo && meeting.linkedMeetingInfo.length !=0"
                                    class="mx-1" tooltip="Follow-up Meeting - {{ meeting.linkedMeetingInfo.length }}"
                                    placement="left" (click)="openLinkMeeting(meeting)">history</mat-icon>
                                <mat-icon tooltip="Zoom meeting" class="d-flex" placement="bottom" triggers="hover"
                                    *ngIf="meeting.zoomMeetingId!=null" (click)="joinZoomMeeting(meeting.zoomJoinURL)">
                                    <img src="assets/zoom1.png"></mat-icon>
                                <mat-icon tooltip="Meeting has started" placement="bottom" triggers="hover"
                                    *ngIf="meeting.meetingStartFlag == 'Y' && meeting.facilitator || meeting.meetingStartFlag == 'Y'"
                                    (click)="startMeeting(meeting)"> directions_run</mat-icon>
                                <button mat-icon-button placement="left" tooltip="Information" triggers="hover">
                                    <!-- <mat-icon class="info-mat-icon" (click)="loadMeetingInfo(meeting.meetingId)">info</mat-icon> -->
                                    <mat-icon class="info-mat-icon" (click)="loadMeetingInfo(meeting)">info</mat-icon>
                                </button>
                                <button mat-icon-button [matMenuTriggerFor]="menu" placement="left" tooltip="More"
                                    triggers="hover">
                                    <mat-icon class="vert-mat-icon">more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item
                                        class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize"
                                        (click)="scheduleMeeting(meeting)"
                                        *ngIf="meeting.rescheduleFlag=='' &&  meeting.meetingStartFlag=='' ">

                                        <h3 class="mat-menu-content-alignment text-capitalize margin-0">schedule meeting
                                        </h3>
                                    </button>
                                    <button
                                        class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize"
                                        mat-menu-item *ngIf="meeting.rescheduleFlag==''"
                                        [disabled]="(meeting.meetingStartFlag=='Y'?true:false)"
                                        (click)="deleteMeeting(meeting)">

                                        <h3 class="mat-menu-content-alignment text-capitalize margin-0">delete meeting
                                        </h3>
                                    </button>
                                    <button
                                        class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize"
                                        mat-menu-item (click)="reScheduleMeetingPopup(meeting)"
                                        *ngIf="meeting.rescheduleFlag=='Y' && meeting.meetingStartFlag!='Y'">

                                        <h3 class="mat-menu-content-alignment text-capitalize margin-0">re-schedule
                                            meeting</h3>
                                    </button>
                                    <button
                                        class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize"
                                        mat-menu-item (click)="cancelMeetingPopup(meeting)"
                                        *ngIf="meeting.rescheduleFlag=='Y'">

                                        <h3 class="mat-menu-content-alignment text-capitalize margin-0">cancel meeting
                                        </h3>
                                    </button>
                                    <button
                                        class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize"
                                        mat-menu-item (click)="openLinkMeeting(meeting)">

                                        <h3 class="mat-menu-content-alignment text-capitalize margin-0">link meetings
                                        </h3>
                                    </button>
                                    <button *ngIf="meeting.momStatus == 'A' " (click)="viewMomPdf(meeting)"
                                        style="background-color: var(--bttn-primary);color: var(--bttn-light);"
                                        mat-menu-item>
                                        VIEW MOM
                                    </button>
                                </mat-menu>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="menu">
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell style="flex: auto;" *matCellDef="let meeting"
                                class="col-md-2 col-sm-1 col-1 justify-content-end">
                                <mat-icon tooltip="Zoom meeting" class="d-flex" placement="bottom" triggers="hover"
                                    *ngIf="meeting.zoomMeetingId!=null" (click)="joinZoomMeeting(meeting.zoomJoinURL)">
                                    <img src="assets/zoom1.png"></mat-icon>
                                <mat-icon tooltip="Meeting has started" placement="bottom" triggers="hover"
                                    *ngIf="meeting.meetingStartFlag == 'Y' && meeting.facilitator || meeting.meetingStartFlag == 'Y'"
                                    (click)="startMeeting(meeting)"> directions_run</mat-icon>
                                <button mat-icon-button [matMenuTriggerFor]="menu" placement="left" tooltip="More"
                                    triggers="hover">
                                    <mat-icon class="vert-mat-icon">more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item
                                        style="background-color: var(--strt-bttn-bg);color: var(--bttn-light);" *ngIf="meeting.meetingStartEnable == 'Y'  
                                && meeting.rescheduleFlag =='Y' 
                                && meeting.meetingStartFlag != 'Y'
                                && meeting.enableStartButton == 'Start' 
                                && meeting.attendeeLoginFlag != 'Y'"
                                        class="body-font-size d-flex align-items-center menu-btn-alignment justify-content-center"
                                        (click)="startMeeting(meeting)">
                                        START
                                    </button>
                                    <button mat-menu-item
                                        style="background-color: var(--strt-bttn-bg);color: var(--bttn-light);"
                                        *ngIf="meeting.meetingStartEnable == 'N' && meeting.enableStartButton == 'Start' && meeting.attendeeLoginFlag != 'Y'"
                                        class="body-font-size d-flex align-items-center justify-content-center menu-btn-alignment"
                                        (click)="startMeeting(meeting)">
                                        JOIN
                                    </button>
                                    <button class="body-font-size d-flex align-items-center menu-btn-alignment"
                                        (click)="loadMeetingInfo(meeting)" mat-menu-item>

                                        <h3 class="mat-menu-content-alignment text-capitalize margin-0">meeting info
                                        </h3>
                                    </button>
                                    <button mat-menu-item
                                        class="body-font-size d-flex align-items-center menu-btn-alignment"
                                        (click)="scheduleMeeting(meeting)"
                                        *ngIf="meeting.rescheduleFlag=='' &&  meeting.meetingStartFlag=='' ">

                                        <h3 class="mat-menu-content-alignment text-capitalize margin-0">schedule meeting
                                        </h3>
                                    </button>
                                    <button class="body-font-size d-flex align-items-center menu-btn-alignment"
                                        mat-menu-item *ngIf="meeting.rescheduleFlag==''"
                                        [disabled]="(meeting.meetingStartFlag=='Y'?true:false)"
                                        (click)="deleteMeeting(meeting)">
                                        <h3 class="mat-menu-content-alignment text-capitalize margin-0">delete meeting
                                        </h3>
                                    </button>
                                    <button class="body-font-size d-flex align-items-center menu-btn-alignment"
                                        mat-menu-item (click)="reScheduleMeetingPopup(meeting)"
                                        *ngIf="meeting.rescheduleFlag=='Y' && meeting.meetingStartFlag!='Y'">
                                        <h3 class="mat-menu-content-alignment text-capitalize margin-0">re-schedule
                                            meeting</h3>
                                    </button>
                                    <button meetingclass="body-font-size d-flex align-items-center menu-btn-alignment"
                                        mat-menu-item (click)="cancelMeetingPopup(meeting)"
                                        *ngIf="meeting.rescheduleFlag=='Y'">
                                        <h3 class="mat-menu-content-alignment text-capitalize margin-0">cancel meeting
                                        </h3>
                                    </button>
                                    <button class="body-font-size d-flex align-items-center menu-btn-alignment"
                                        mat-menu-item (click)="openLinkMeeting(meeting)">
                                        <h3 class="mat-menu-content-alignment text-capitalize margin-0">link meetings
                                        </h3>
                                    </button>
                                </mat-menu>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

                        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                        <tr class="matRow" *matNoDataRow>
                            <td class="matCell" colspan="4" *ngIf="this.meetingDatasource.totalCount=== 0">No data
                                matching the filter</td>
                        </tr>
                    </mat-table>
                </ng-scrollbar>
            </mat-tab>





            <mat-tab label="Completed" class="body-font-size">
                <div class="meeting-indicator">
                    <mat-progress-spinner mode="indeterminate" [diameter]="20"
                        *ngIf="meetingDatasource.loading$ | async" bdColor="rgba(51,51,51,0.8)"></mat-progress-spinner>
                </div>

                <ng-scrollbar
                    [ngClass]="sideNavService.returnExpandFullScreeBooleanSetter() ? 'panel-fullscreen-card-inner-past-upcoming' : 'global-containers'"
                    #scrollable pointerEventsMethod="scrollbar" [disabled]="disabled">
                    <mat-table class="table-mat upcomming-mat-row" [dataSource]="meetingDatasource">
                        <ng-container matColumnDef="meetingTitle">
                            <mat-header-cell *matHeaderCellDef>Meeting Title</mat-header-cell>
                            <mat-cell style="flex: none;"
                                [ngClass]="!sideNavService.returnExpandFullScreeBooleanSetter() ? 'col-xl-6 col-lg-6' : 'col-8'"
                                *matCellDef="let meeting">
                                <div
                                    [ngStyle]="sideNavService.returnExpandFullScreeBooleanSetter() && (deviceXl || deviceLg) ? {'display' : 'contents'} : {}">
                                    <!-- <div> -->
                                    <!-- <h2 class="body-font-size margin-0">{{meeting.meetingTitle}}</h2> -->
                                    <h4 class="f-weight pd-r-10px pointer hght-inh margin-0" tooltip="Meeting Title"
                                        triggers="hover" placement="left" id="PAST" [routerLink]=""
                                        (click)="RedirectToCompletedMeeting(meeting)">
                                        <!-- <a id="PAST" [routerLink]="" (click)="redirectToMeeting(meeting)"> -->
                                        {{meeting.meetingTitle}}
                                        <!-- </a> -->
                                    </h4>
                                    <div *ngIf="meeting.isTaskExist=='Y'">
                                        <a class="pointer task-dlg-color"
                                            (click)="LoadCompletedMeetingInfo(meeting)">View Task Status</a>
                                    </div>
                                </div>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="responsiveMeetingTitle">
                            <mat-header-cell *matHeaderCellDef>Meeting Title</mat-header-cell>
                            <mat-cell style="flex: none;" class="col-md-9 col-sm-9 col-9" *matCellDef="let meeting">
                                <div>
                                    <!-- <div> -->
                                    <!-- <h2 class="body-font-size margin-0">{{meeting.meetingTitle}}</h2> -->
                                    <h4 [routerLink]="" (click)="RedirectToCompletedMeeting(meeting)"
                                        tooltip="{{meeting.meetingTitle}}" triggers="hover" id="PAST" placement="left"
                                        class="margin-0 f-weight hght-inh">
                                        <!-- <a [routerLink]="" (click)="redirectToMeeting(meeting)"> -->
                                        {{meeting.meetingTitle}}
                                        <!-- </a> -->
                                    </h4>
                                    <!-- </div> -->
                                    <!-- <div>
                                    <h2 style="font-size: 13px;line-height: initial;" class="body-font-size margin-0"><span class="italic assignedBy" style="font-size : 13px !important">Meeting Status: </span> <span class="body-font-size">Approved</span></h2>
                                    <h2 class="body-font-size margin-0"> Approved</h2>
                                </div> -->
                                    <div *ngIf="meeting.isTaskExist=='Y'">
                                        <a class="pointer task-dlg-color"
                                            (click)="LoadCompletedMeetingInfo(meeting)">View Task Status</a>
                                    </div>
                                </div>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="meetingDate">
                            <mat-header-cell *matHeaderCellDef>Meeting Date</mat-header-cell>
                            <mat-cell *matCellDef="let meeting"
                                [ngStyle]="sideNavService.returnExpandFullScreeBooleanSetter() && (deviceXl || deviceLg) ? {'width' : '185px'} : {}"
                                [ngClass]="!sideNavService.returnExpandFullScreeBooleanSetter() ? 'past-met-cell col-4 col-sm-2 col-md-2 col-lg-2 col-xl-2 pd-r-10px' : 'past-met-cell col pd-r-10px'"
                                style="flex: none;">
                                <div
                                    [ngStyle]="sideNavService.returnExpandFullScreeBooleanSetter() && (deviceXl || deviceLg) ? {'display' : 'contents'} : {}">
                                    <h4 class="margin-0 f-weight line-height-1 no-wrap">{{meeting.meetingDateStr |
                                        date:'mediumDate'}}</h4>
                                    <h4
                                        [ngClass]="sideNavService.returnExpandFullScreeBooleanSetter() && (deviceXl || deviceLg) ? 'margin-0 pd-l-5' : 'margin-0'">
                                        &#64; {{meeting.meetingStartTime}} {{meeting.meetingTimeZone}}</h4>
                                </div>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="meetingId">
                            <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
                            <mat-cell *matCellDef="let meeting">{{meeting.meetingId}}</mat-cell>

                        </ng-container>
                        <ng-container matColumnDef="action">
                            <mat-header-cell *matHeaderCellDef>Meeting Action</mat-header-cell>
                            <mat-cell style="flex: none; padding-right: 10px;"
                                [ngClass]="!sideNavService.returnExpandFullScreeBooleanSetter() ? 'col-xl-3 col-lg-3 justify-content-end' : 'col-2 justify-content-end'"
                                *matCellDef="let meeting">
                                <mat-icon style="cursor: pointer;"
                                    *ngIf="meeting.linkedMeetingInfo && meeting.linkedMeetingInfo.length !=0"
                                    class="mx-1" tooltip="Follow-up Meeting - {{ meeting.linkedMeetingInfo.length }}"
                                    placement="left" (click)="openLinkMeeting(meeting)">history</mat-icon>
                                <button *ngIf="meeting.momStatus == 'Com'"
                                    style="background-color: var(--bttn-primary);color: var(--bttn-light);"
                                    mat-raised-button>
                                    <mat-icon>check_circle</mat-icon>
                                </button>
                                <button *ngIf="meeting.momStatus == 'A'" (click)="viewMomPdf(meeting)"
                                    style="background-color: var(--bttn-primary);color: var(--bttn-light);"
                                    mat-raised-button>
                                    VIEW MOM
                                </button>
                                <button *ngIf="meeting.meetingStatusCode == 'CAN'" tooltip="{{meeting.cancelledReason}}"
                                    color="warn" mat-stroked-button>
                                    CANCELLED
                                </button>
                                <button *ngIf="meeting.meetingStatusCode == 'PAST'" (click)="notHeldPopup(meeting)"
                                    tooltip="{{meeting.notHeldReason}}" color="warn" mat-stroked-button>
                                    NOT HELD
                                </button>
                                <!-- <button *ngIf = "(meeting.meetingDateStr | date:'mediumDate') == currentDate && (meeting.meetingStartTime | date:'shortTime') == (currentDate | date:'shortTime')" mat-raised-button>
                                START
                            </button> -->
                                <!-- <button *ngIf = "(meeting.meetingDateStr | date:'mediumDate') == currentDate && timeChecker(meeting.meetingStartTime, currentDate | date:'shortTime' )" mat-raised-button>
                                JOIN {{currentDate | date:'shortTime'}}
                            </button> -->
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="getdetails">
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell style="flex: auto;" *matCellDef="let meeting"
                                [ngClass]="!sideNavService.returnExpandFullScreeBooleanSetter() ? 'col-xl-1 col-lg-1 justify-content-end' : 'col-1 justify-content-end'">
                                <!--<button mat-raised-button color="primary" (click)="loadMeetingInfo(meeting.meetingId)">Info</button>-->
                                <!-- <button mat-icon-button><mat-icon class="info-mat-icon" (click)="loadMeetingInfo(meeting.meetingId)">info</mat-icon>
                            </button> -->
                                <button mat-icon-button [matMenuTriggerFor]="menu" triggers="hover" tooltip="More"
                                    placement="left"><mat-icon class="vert-mat-icon">more_vert</mat-icon></button>
                                <mat-menu #menu="matMenu">
                                    <button class="body-font-size d-flex align-items-center" mat-menu-item
                                        (click)="copyMeeting(meeting)">
                                        <h3 class="text-capitalize margin-0">copy meeting / follow-up meeting</h3>
                                    </button>
                                    <button class="body-font-size d-flex align-items-center" mat-menu-item
                                        (click)="openLinkMeeting(meeting)">
                                        <h3 class="text-capitalize margin-0">link meetings</h3>
                                    </button>

                                    <!-- <button (click)="followupPopup(meeting)" class="body-font-size" mat-menu-item >
                                        Follow-up Meeting
                                    </button> -->
                                    <!-- <button class="body-font-size" (click)="deleteMeeting(meeting.meetingId)" mat-menu-item>
                                    Delete Meeting
                                    </button> -->
                                </mat-menu>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="menu">
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell style="flex: auto;" *matCellDef="let meeting"
                                class="col-xs-1 col-md-1 col-sm-1 justify-content-end">
                                <!--<button mat-raised-button color="primary" (click)="loadMeetingInfo(meeting.meetingId)">Info</button>-->
                                <!-- <button mat-icon-button><mat-icon class="info-mat-icon" (click)="loadMeetingInfo(meeting.meetingId)">info</mat-icon>
                            </button> -->
                                <button mat-icon-button [matMenuTriggerFor]="menu" tooltip="More" placement="left"
                                    triggers="hover"><mat-icon class="vert-mat-icon">more_vert</mat-icon></button>
                                <mat-menu #menu="matMenu">
                                    <button *ngIf="meeting.momStatus == 'A' " (click)="viewMomPdf(meeting)"
                                        style="background-color: var(--bttn-primary);color: var(--bttn-light);"
                                        mat-menu-item>
                                        VIEW MOM
                                    </button>
                                    <button *ngIf="meeting.meetingStatusCode == 'CAN'" (click)="notHeldPopup(meeting)"
                                        tooltip="{{meeting.cancelledReason}}" color="warn" mat-menu-item>
                                        CANCELLED
                                    </button>
                                    <button *ngIf="meeting.meetingStatusCode == 'PAST'" (click)="notHeldPopup(meeting)"
                                        tooltip="{{meeting.notHeldReason}}" color="warn" mat-menu-item>
                                        NOT HELD
                                    </button>
                                    <button class="body-font-size d-flex align-items-center" mat-menu-item
                                        (click)="copyMeeting(meeting)">
                                        <h3 class=" text-capitalize margin-0">copy meeting / follow-up meeting</h3>
                                    </button>
                                    <button class="body-font-size d-flex align-items-center" mat-menu-item
                                        (click)="openLinkMeeting(meeting)">
                                        <h3 class=" text-capitalize margin-0">link meetings</h3>
                                    </button>
                                    <!-- <button (click)="followupPopup(meeting)" class="body-font-size" mat-menu-item >
                                        Follow-up Meeting
                                    </button> -->
                                </mat-menu>
                            </mat-cell>
                        </ng-container>


                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

                        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                        <tr class="matRow" *matNoDataRow>
                            <td class="matCell " colspan="4" *ngIf="this.meetingDatasource.totalCount=== 0">No data
                                matching the filter</td>
                        </tr>
                    </mat-table>
                </ng-scrollbar>

            </mat-tab>

        </mat-tab-group>


    </div>
    <mat-divider></mat-divider>
    <div class="footer-container">
        <mat-paginator style="height: 35px !important;" [pageSizeOptions]="[10,25,50,75,100]"
            [pageSize]="(sideNavService.returnExpandFullScreeBooleanSetter() && deviceXl) ? 20 : (sideNavService.returnExpandFullScreeBooleanSetter() && deviceLg) ? 20 : 10"></mat-paginator>
    </div>
</mat-card>
